import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import React from 'react';
import { useFonts } from '@use-expo/font';
// eslint-disable-next-line no-unused-vars
import Firebase from './firebase';
import ResponsiveApp from './responsiveApp';
import { store, persistor } from './src/store';

export default () => {
  const [loaded] = useFonts({
    // eslint-disable-next-line global-require
    Pacifico: require('./src/assets/fonts/Pacifico.ttf'),
    // eslint-disable-next-line global-require
    Nunito_Regular: require('./src/assets/fonts/Nunito_Regular.ttf'),
    // eslint-disable-next-line global-require
    Nunito_SemiBold: require('./src/assets/fonts/Nunito_SemiBold.ttf'),
    // eslint-disable-next-line global-require
    Nunito_Bold: require('./src/assets/fonts/Nunito_Bold.ttf'),
    // eslint-disable-next-line global-require
    Nunito_ExtraBold: require('./src/assets/fonts/Nunito_ExtraBold.ttf'),
  });

  if (!loaded) {
    return null; // eventuell loading screen
  }

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ResponsiveApp />
      </PersistGate>
    </Provider>
  );
};
